import styled, { css } from 'styled-components';

import { ReactComponent as TrashIconBase } from 'assets/icons/primary-trash.svg';

export const TrashIcon = styled(TrashIconBase)<{ disabled: boolean }>(
  ({ disabled, theme: { palette } }) => css`
    cursor: ${disabled ? 'default' : 'pointer'};
    opacity: ${disabled ? 0.5 : 1};

    path {
      fill: ${disabled ? palette.grey[600] : '#2D6CE6'};
    }
  `,
);
